﻿export const isAddRowSymbol: unique symbol = Symbol.for("Serenity.isAddRow");
export const isAssignableFromSymbol: unique symbol = Symbol.for("Serenity.isAssignableFrom");
export const isInstanceOfTypeSymbol: unique symbol = Symbol.for("Serenity.isInstanceOfType");
export const implementedInterfacesSymbol: unique symbol = Symbol.for("Serenity.implementedInterfaces");
export const localTextTableSymbol: unique symbol = Symbol.for("Serenity.localTextTable");
export const scriptDataHashSymbol: unique symbol = Symbol.for("Serenity.scriptDataHash");
export const scriptDataSymbol: unique symbol = Symbol.for("Serenity.scriptData");
export const typeInfoSymbol: unique symbol = Symbol.for("Serenity.typeInfo");
export const typeRegistrySymbol: unique symbol = Symbol.for("Serenity.typeRegistry");

